import ProductoService from 'src/modules/producto/productoService';
import Errors from 'src/modules/shared/error/errors';
import Message from 'src/view/shared/message';
import { getHistory } from 'src/modules/history';
import { i18n } from 'src/i18n';

const prefix = 'PRODUCTO_FORM';

const productoFormActions = {
  INIT_STARTED: `${prefix}_INIT_STARTED`,
  INIT_SUCCESS: `${prefix}_INIT_SUCCESS`,
  INIT_ERROR: `${prefix}_INIT_ERROR`,

  CREATE_STARTED: `${prefix}_CREATE_STARTED`,
  CREATE_SUCCESS: `${prefix}_CREATE_SUCCESS`,
  CREATE_ERROR: `${prefix}_CREATE_ERROR`,

  UPDATE_STARTED: `${prefix}_UPDATE_STARTED`,
  UPDATE_SUCCESS: `${prefix}_UPDATE_SUCCESS`,
  UPDATE_ERROR: `${prefix}_UPDATE_ERROR`,

  doInit: (id) => async (dispatch) => {
    try {
      dispatch({
        type: productoFormActions.INIT_STARTED,
      });

      let record = {};

      const isEdit = Boolean(id);

      if (isEdit) {
        record = await ProductoService.find(id);
      }

      dispatch({
        type: productoFormActions.INIT_SUCCESS,
        payload: record,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: productoFormActions.INIT_ERROR,
      });

      getHistory().push('/producto');
    }
  },

  doCreate: (values) => async (dispatch) => {
    try {
      dispatch({
        type: productoFormActions.CREATE_STARTED,
      });

      await ProductoService.create(values);

      dispatch({
        type: productoFormActions.CREATE_SUCCESS,
      });

      Message.success(
        i18n('entities.producto.create.success'),
      );

      getHistory().push('/producto');
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: productoFormActions.CREATE_ERROR,
      });
    }
  },

  doUpdate: (id, values) => async (dispatch, getState) => {
    try {
      dispatch({
        type: productoFormActions.UPDATE_STARTED,
      });

      await ProductoService.update(id, values);

      dispatch({
        type: productoFormActions.UPDATE_SUCCESS,
      });

      Message.success(
        i18n('entities.producto.update.success'),
      );

      getHistory().push('/producto');
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: productoFormActions.UPDATE_ERROR,
      });
    }
  },
};

export default productoFormActions;
